/**
 * Urgency level to status style mapping
 * Maps urgency levels to appropriate status styles
 */

export const DATA_BADGE_STYLES: Record<'DEFAULT' | 'DANGER', string> = {
  DEFAULT: 'tw:bg-white tw:text-zinc-800 tw:border-zinc-300',
  DANGER: 'tw:bg-white tw:text-red-700 tw:border-zinc-300',
};

export const URGENCY_LEVEL_STYLE_MAP: Record<string, string> = {
  1: DATA_BADGE_STYLES.DEFAULT,
  2: DATA_BADGE_STYLES.DEFAULT,
  3: DATA_BADGE_STYLES.DEFAULT,
  4: DATA_BADGE_STYLES.DEFAULT,
  5: DATA_BADGE_STYLES.DANGER,
};

/**
 * Urgency level icon mapping
 */
export const URGENCY_LEVEL_ICONS: Record<string, string> = {
  1: 'far fa-circle-info tw:text-zinc-600',
  2: 'fas fa-exclamation-triangle tw:text-stoplight-warning',
  3: 'fas fa-exclamation-triangle tw:text-stoplight-warning',
  4: 'fas fa-bell tw:text-red-700',
  5: 'fas fa-bell-on tw:text-red-700',
};
